import React from 'react';
import { WipeAnimation } from './Wipe.styles';
import { AnimationComponentProps } from '../types';

export const WIPE_DEFAULT_SPEED = 0.7;

export const Wipe = (props: AnimationComponentProps) => {
  const {
    children,
    speed = WIPE_DEFAULT_SPEED,
    isNav,
    isAbsoluteImage,
    direction,
    delay,
    easeFunction = 'cubic-bezier(0.1, 0, 0.1, 1)',
  } = props;

  const { wipeDirection } = direction || {};

  return (
    <WipeAnimation
      isNav={isNav}
      isStandard={!isNav && !isAbsoluteImage}
      speed={speed}
      isAbsoluteImage={isAbsoluteImage}
      wipeDirection={wipeDirection || 'down'}
      delay={delay || 0}
      easeFunction={easeFunction}
    >
      {children}
    </WipeAnimation>
  );
};
